import { render, staticRenderFns } from "./SelectedCentreInfo.vue?vue&type=template&id=a4319e6c&scoped=true"
import script from "./SelectedCentreInfo.vue?vue&type=script&lang=js"
export * from "./SelectedCentreInfo.vue?vue&type=script&lang=js"
import style0 from "./SelectedCentreInfo.vue?vue&type=style&index=0&id=a4319e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4319e6c",
  null
  
)

export default component.exports